// Своя доставка продавца на оформлении заказа (веб-витрина).
import type { DeliveryOption, DeliveryQuoteGroup, SelfDeliveryOffer, SelfDeliveryShopOption } from "@/api";

// Своя доставка продавца (продавец включил «Доставляю сам» для города
// покупателя, GET /delivery/self-options) — ещё одна опция группы «до двери».
// Цену и срок шлюз пересчитает сам по настройкам продавца (carrier:"self").
export const SELF_DELIVERY_LABEL = "Доставка продавцом";
export const selfOptionOf = (offer: SelfDeliveryOffer): DeliveryOption => ({
	carrier: "self",
	label: SELF_DELIVERY_LABEL,
	deliverySum: offer.price,
	deliveryDays: offer.deliveryDays,
	toPickupPoint: false,
});

// Опции квоты + своя доставка продавца, по группе магазина.
export const withSelfDelivery = (groups: DeliveryQuoteGroup[], self: SelfDeliveryShopOption[]): DeliveryQuoteGroup[] => {
	const offers = new Map(self.flatMap((o) => (o.offer ? [[o.shopId, o.offer] as const] : [])));
	return groups.map((g) => {
		const offer = offers.get(g.shopId);
		return offer ? { ...g, options: [...g.options.filter((o) => o.carrier !== "self"), selfOptionOf(offer)] } : g;
	});
};

// Предложение продавца по его группе — для условий и «бесплатно от».
export const selfOfferMap = (self: SelfDeliveryShopOption[]): Map<string, SelfDeliveryOffer> =>
	new Map(self.flatMap((o) => (o.offer ? [[o.shopId, o.offer] as const] : [])));

// «Бесплатно от N ₽»: сколько осталось добрать до бесплатной доставки
// продавца. null — порога нет или он уже достигнут (тогда цена уже 0).
export const selfFreeOverLeft = (offer: SelfDeliveryOffer, groupSubtotal: number): number | null => {
	if (offer.freeOver == null || offer.freeOver <= 0) return null;
	const left = Math.round((offer.freeOver - groupSubtotal) * 100) / 100;
	return left > 0 ? left : null;
};
